import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class SupplierInvoiceService {
  async getAll(
    projectId: string,
    query?: models.GetSupplierInvoicesQuery,
  ): Promise<models.SupplierInvoicesResponse[]> {
    const invoices = await appHttpService.request
      .url(`/supplier-invoices/${projectId}`)
      .query(query ?? '')
      .get()
      .json<models.SupplierInvoicesResponse[]>();
    return invoices;
  }

  async get(id: string): Promise<models.SupplierInvoiceResponse> {
    const invoice = await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}`)
      .get()
      .json<models.SupplierInvoiceResponse>();
    return invoice;
  }
  async updateSupplierInvoice(
    id: string,
    body: models.UpdateSupplierInvoiceBody,
  ): Promise<models.SupplierInvoiceResponse> {
    const rows = await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}`)
      .put(body)
      .json<models.SupplierInvoiceResponse>();
    return rows;
  }

  async getSupplierInvoiceNotifications(): Promise<models.GetSupplierInvoiceNotificationsResponse> {
    return await appHttpService.request
      .url('/supplier-invoices/notifications')
      .get()
      .json<models.GetSupplierInvoiceNotificationsResponse>();
  }

  async getSupplierInvoiceReviewers(
    id: string,
  ): Promise<models.FortnoxUserReviewStatus[]> {
    const reviewers = await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}/review`)
      .get()
      .json<models.FortnoxUserReviewStatus[]>();
    return reviewers;
  }

  async updateSupplierInvoiceReviewers(
    updatedReviewers: models.FortnoxUserReviewRanking[],
    id: string,
  ): Promise<void> {
    await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}/review`)
      .put({ reviewers: updatedReviewers });
  }

  async updateSupplierInvoiceProject(
    invoiceId: string,
    body: { projectId: string },
  ): Promise<void> {
    await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${invoiceId}/project`)
      .put(body)
      .res();
  }

  async approveSupplierInvoice(
    id: string,
  ): Promise<models.FortnoxUserReviewStatus[]> {
    return await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}/review/approve`)
      .put({})
      .json<models.FortnoxUserReviewStatus[]>();
  }

  async contestSupplierInvoice(
    id: string,
  ): Promise<models.FortnoxUserReviewStatus[]> {
    return await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}/review/contest`)
      .put({})
      .json<models.FortnoxUserReviewStatus[]>();
  }

  async parkSupplierInvoice(
    id: string,
  ): Promise<models.FortnoxUserReviewStatus[]> {
    return await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}/review/park`)
      .put({})
      .json<models.FortnoxUserReviewStatus[]>();
  }

  async getFiles(id: string): Promise<models.SupplierInvoiceFile[]> {
    return await appHttpService.request
      .url(`/supplier-invoices/supplier-invoice/${id}/files`)
      .get()
      .json<models.SupplierInvoiceFile[]>();
  }
}

export const supplierInvoiceService = new SupplierInvoiceService();
